module.exports = __webpack_public_path__ + "static/media/icon-cliente-alternativo.45871345.svg";